<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <div v-if="modalUser" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div v-if="errors.valid == false" class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
              </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                {{ titleModal }}
              </h3>

              <div class="flex flex-col px-10 xl:px-0">

                <p class="py-4">
                  <input
                    v-model="user.email"
                    aria-label="email"
                    type="text"
                    placeholder="E-mail"
                    autofocus="autofocus"
                    :class="errors.email != null ? 'border-red-500' : ''"
                    class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
                  />
                  <span v-if="errors.email != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.email }}
                  </span>
                </p>

                <p class="py-4">
                  <input
                    v-model="user.name"
                    aria-label="name"
                    type="text"
                    placeholder="Nombre y Apellido"
                    autofocus="autofocus"
                    :class="errors.name != null ? 'border-red-500' : ''"
                    class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
                  />
                  <span v-if="errors.name != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.name }}
                  </span>
                </p>

                <p class="py-4">
                  <input
                    v-model="user.identity_number"
                    aria-label="identity_number"
                    type="number"
                    placeholder="DNI"
                    autofocus="autofocus"
                    :class="errors.identity_number != null ? 'border-red-500' : ''"
                    class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
                  />
                  <span v-if="errors.identity_number != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.identity_number }}
                  </span>
                </p>

                <p class="py-4">
                  <input
                    v-model="user.tel"
                    aria-label="name"
                    type="text"
                    placeholder="Teléfono"
                    autofocus="autofocus"
                    class="w-full px-3 py-2 text-gray-800 border rounded shadow appearance-none hover:shadow-lg"
                  />
                </p>
              
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="modalUser = false"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-red-300 px-4 py-2 bg-white text-base leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                </path>
              </svg>
              Cancelar
            </button>
          </span>

          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button 
              @click="save"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-green-300 px-4 py-2 bg-white text-base leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                </path>
              </svg>
              Aceptar
            </button>
          </span>

          <span class="pr-4">
            <div v-if="loading">
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#338BFF">
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)" stroke-width="2">
                            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="1s"
                                    repeatCount="indefinite"/>
                            </path>
                        </g>
                    </g>
                </svg>
            </div>
          </span>
        </div>
      </div>
    </div>

    <table-search @data-filter="filterUsers($event)"></table-search>
    <button
      @click="create"
      type="button"
      class="inline-flex items-center px-5 py-2 mx-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-green-700 border border-transparent rounded-md hover:bg-gray-600 focus:outline-none focus:shadow-outline-gray focus:border-gray-800"
    >
      <svg
        class="w-5 h-5 mr-2 -ml-1 text-white-400"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path 
          d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10">
        </path>
      </svg>
      Nuevo
    </button>
    <div class="flex flex-col">
      <div
        class="py-12 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
      >
        <div
          class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg"
        >
          <table class="min-w-full">
            <thead>
              <tr>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  Usuario
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  E-mail
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  Teléfono
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  Estado
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  Roles
                </th>

                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                ></th>
              </tr>
            </thead>

            <tbody class="bg-white">
              <tr v-for="user in users" :key="user.id">
                <td
                  class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="flex items-center">
                    <div class="flex-shrink-0 w-10 h-10">
                      <img
                        v-if="user.roles.length == 0"
                        class="w-10 h-10 rounded-full"
                        :src="require('../assets/images/noavatar.png')"
                        alt=""
                      />
                      <img
                        v-if="user.roles.length > 0"
                        class="w-10 h-10 rounded-full"
                        :src="require('../assets/images/user-happer.png')"
                        alt=""
                      />
                    </div>
                    <div class="ml-4">
                      <div class="text-sm font-medium leading-5 text-gray-900">
                        {{ user.person.name }}
                      </div>
                    </div>
                  </div>
                </td>

                <td
                  class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="text-sm leading-5 text-gray-500">
                    {{ user.email }}
                  </div>
                </td>

                <td
                  class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <div class="text-sm leading-5 text-gray-500">
                    {{ user.person.tel }}
                  </div>
                </td>

                <td
                  class="px-6 py-4 whitespace-no-wrap border-b border-gray-200"
                >
                  <span
                    v-if="user.active"
                    class="inline-flex px-3 py-1 text-sm font-semibold leading-5 text-green-800 bg-green-200 rounded-full"
                  >
                    Activo
                  </span>
                  <span
                    v-if="!user.active"
                    class="inline-flex px-3 py-1 text-sm font-semibold leading-5 text-red-800 bg-red-200 rounded-full"
                  >
                    Bloqueado
                  </span>
                </td>

                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-500 whitespace-no-wrap border-b border-gray-200"
                >
                  {{ user.roles.join(', ') }}
                </td>

                <td class="py-4 rounded-md">
                  <div class="flex flex-row-reverse">
                    <button
                      v-if="user.active"
                      type="button"
                      @click="lock(user)"
                      class="inline-flex items-center px-5 py-2 mx-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-red-500 border border-transparent rounded-md hover:bg-gray-600 focus:outline-none focus:shadow-outline-gray focus:border-gray-800"
                    >
                      <svg
                        class="w-5 h-5 mr-2 -ml-1 text-white-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M11,14.7324356 C11.5978014,14.3866262 12,13.7402824 12,13 C12,11.8954305 11.1045695,11 10,11 C8.8954305,11 8,11.8954305 8,13 C8,13.7402824 8.40219863,14.3866262 9,14.7324356 L9,17 L11,17 L11,14.7324356 Z M13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 L7,8 L13,8 L13,6 Z M4,8 L4,6 C4,2.6862915 6.6862915,0 10,0 C13.3137085,0 16,2.6862915 16,6 L16,8 L17.0049107,8 C18.1067681,8 19,8.90195036 19,10.0085302 L19,17.9914698 C19,19.1007504 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.0980496 1,17.9914698 L1,10.0085302 C1,8.8992496 1.8926228,8 2.99508929,8 L4,8 Z">
                        </path>
                      </svg>
                      Bloquear
                    </button>

                    <button
                      v-if="!user.active"
                      type="button"
                      @click="unlock(user)"
                      class="inline-flex items-center px-5 py-2 mx-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-green-500 border border-transparent rounded-md hover:bg-gray-600 focus:outline-none focus:shadow-outline-gray focus:border-gray-800"
                    >
                      <svg
                        class="w-5 h-5 mr-2 -ml-1 text-white-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M11,14.7324356 C11.5978014,14.3866262 12,13.7402824 12,13 C12,11.8954305 11.1045695,11 10,11 C8.8954305,11 8,11.8954305 8,13 C8,13.7402824 8.40219863,14.3866262 9,14.7324356 L9,17 L11,17 L11,14.7324356 Z M13,6 C13,4.34314575 11.6568542,3 10,3 C8.34314575,3 7,4.34314575 7,6 L7,8 L13,8 L13,6 Z M4,8 L4,6 C4,2.6862915 6.6862915,0 10,0 C13.3137085,0 16,2.6862915 16,6 L13,6 L13,8 L17.0049107,8 C18.1067681,8 19,8.90195036 19,10.0085302 L19,17.9914698 C19,19.1007504 18.1073772,20 17.0049107,20 L2.99508929,20 C1.8932319,20 1,19.0980496 1,17.9914698 L1,10.0085302 C1,8.8992496 1.8926228,8 2.99508929,8 L4,8 Z">
                        </path>
                      </svg>
                      Desbloquear
                    </button>

                    <button
                      type="button"
                      @click="edit(user)"
                      class="inline-flex items-center px-4 py-2 mx-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-blue-500 border border-transparent rounded-md hover:bg-gray-600 focus:outline-none focus:shadow-outline-gray focus:border-gray-800"
                    >
                      <svg
                        class="w-5 h-5 mr-2 -ml-1 text-white-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                        />
                      </svg>
                      Editar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table-pagination :meta="meta" :links="links" @data-paginate="fetchUsersPaginate($event)"></table-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import TableSearch from '@/components/TableSearch'
import TablePagination from '@/components/TablePagination'
import VueAlertify from 'vue-alertify';

Vue.use(VueAlertify);

export default {
  components: { TableSearch, TablePagination },

  data() {
    return {
      modalUser: false,
      loading: false,
      errors: {
        email: null,
        name: null,
        identity_number: null,
        valid: true,
      },
      users: null,
      links: null,
      meta: null,
      titleModal: '',
      user: {
        id: null,
        name: null,
        tel: null
      },
    }
  },

  mounted() {
    this.fetchUsers()
  },

  computed: {
    perPage() {
      return (this.meta && this.meta.per_page) || 10
    },
  },

  methods: {
    async fetchUsersPaginate(paginate){
      const perPage = paginate.perPage
      const page = paginate.page
      const { data, links, meta } = await this.$http.get(`/users?perPage=${perPage}&page=${page}`)

      this.users = data
      this.links = links
      this.meta = meta
    },
    async fetchUsers() {
      const { data, links, meta } = await this.$http.get(`/users?perPage=${this.perPage}`)

      this.users = data
      this.links = links
      this.meta = meta
    },
    async filterUsers(query) {
      if (query == ''){
        this.fetchUsers()
      } else {
        const { data, links, meta } = await this.$http.get(`/users/filter/${query}?perPage=${this.perPage}`)

        this.users = data
        this.links = links
        this.meta = meta
      }
    },
    lock(user) {
      this.$alertify.confirmWithTitle(
        'Bloquear Usuario',
        `¿Esta seguro que desea bloquear a ${user.person.name}?`,
        async () => {
          try {
            await this.$http.patch(`/users/lock/${user.id}`)
            user.active = false
            this.$alertify.success('El usuario ha sido bloqueado!') 
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido bloquear el usuario!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    unlock(user) {
      this.$alertify.confirmWithTitle(
        'Desbloquear Usuario',
        `¿Esta seguro que desea desbloquear a ${user.person.name}?`,
        async () => {
          try {
            await this.$http.patch(`/users/unlock/${user.id}`)
            user.active = true
            this.$alertify.success('El usuario ha sido desbloqueado!') 
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido desbloquear el usuario!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    create() {
      this.cleanErrors()
      this.user = {
        id: null,
        name: null,
        identity_number: null,
        tel: null
      }
      this.titleModal = 'Nuevo Usuario'
      this.modalUser = true
    },
    edit(user) {
      this.cleanErrors()
      this.user.id = user.id
      this.user.name = user.person.name
      this.user.email = user.email
      this.identity_number = user.identity_number
      this.titleModal = 'Editar Usuario'
      this.modalUser = true
    },
    cleanErrors() {
      this.loading = false
      this.errors = {
        email: null,
        name: null,
        identity_number: null,
        valid: true,
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateForm() {
      this.cleanErrors()
      let valid = true

      if (this.user.email == '' || this.user.email == null){
        this.errors.email = "Email Requerido!"
        valid = false
      } else {
          if (!this.validateEmail(this.user.email)){
            this.errors.email = "Email Inválido!"
            valid = false
          }
      }

      if (this.user.name == '' || this.user.name == null){
        this.errors.name = "Nombre y Apellido Requerido!"
        valid = false
      }

      if (this.user.identity_number == '' || this.user.identity_number == null){
        this.errors.identity_number = "DNI Requerido!"
        valid = false
      }

      this.errors.valid = valid
      return valid
    },
    async save() {
      if (this.validateForm()){
        if (this.user.id == null){
          try {
            this.loading = true
            await this.$http.post('/users', this.user)
            this.$alertify.success('El usuario ha sido creado!')
            this.modalUser = false
            await this.fetchUsers()
          } catch (error) {
            if (error.response.status == 422){
              this.errors.valid = false
              this.errors.email = 'El email ya existe.'
            } else {
              this.$alertify.error('ERROR. No se ha podido crear el usuario!')
            }
          } finally {
            this.loading = false
          }
        } else {
          try {
            this.loading = true
            await this.$http.put(`/users/${this.user.id}`, this.user)
            this.$alertify.success('El usuario ha sido modificado!')
            this.modalUser = false
            await this.fetchUsers()
          } catch (error) {
            this.errors.valid = false
            this.errors.email = 'El email ya existe.'
          } finally {
            this.loading = false
          }
        }
      }
    }
  },
}
</script>

